import React, { useContext, useReducer } from 'react';
// Reducer
import appReducer, { type Store, type AppAction } from './AppReducer';

type AppContextDispatch = (action: AppAction) => void;

const AppStateContext = React.createContext<Store | null>(null);
const AppDispatchContext = React.createContext<AppContextDispatch | null>(null);

/**
 * Initial state for the global application context.
 */
const initStore: Store = {
  // Add initial state properties here as needed
};

/**
 * Provider for the global application context.
 * This provider wraps the application in a context provider, allowing components to
 * access the global state and dispatch function.
 */
function AppProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer(appReducer, initStore);

  // useEffect(() => {
  //   //   if you want a persistant context in localstorage, add it here
  // }, [state]);

  return (
    <AppStateContext.Provider value={state}>
      <AppDispatchContext.Provider value={dispatch}>{children}</AppDispatchContext.Provider>
    </AppStateContext.Provider>
  );
}

/**
 * Custom hook for accessing the global application context and dispatch function.
 *
 * This hook simplifies the process of accessing the global state and dispatch function
 * from the application's context. It returns an array containing the current state
 * and the dispatch function, allowing components to read from the global state and
 * dispatch actions to modify it.
 */
const useAppContext = (): [Store | null, AppContextDispatch | null] => [
  useContext(AppStateContext),
  useContext(AppDispatchContext),
];

export { AppDispatchContext, AppProvider, AppStateContext, useAppContext };
